import React from "react";
import PropTypes from "prop-types";

export default function HeaderHelp(props) {
  return (
    <svg
      onClick={props.onClick}
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.69525 6.08048C9.69525 7.28049 9.11925 7.90449 8.20725 8.67249L6.83925 9.80049C5.56725 10.8325 5.37525 11.2165 5.37525 12.7285V14.2645H8.66325V13.2325C8.66325 12.5605 8.83125 12.3445 9.33525 11.9365L10.9432 10.5925C12.5032 9.29649 13.4392 8.09649 13.4392 5.88849C13.4392 3.12849 11.6392 0.896484 7.31925 0.896484C3.02325 0.896484 0.695246 3.53648 0.767246 7.30448H4.41525C4.41525 4.71249 5.71125 3.87248 7.24725 3.87248C8.80725 3.87248 9.69525 4.73649 9.69525 6.08048ZM8.66325 19.3142V16.3525H5.37525V19.3142H8.66325Z"
        fill={props.fill}
      />
    </svg>
  );
}
HeaderHelp.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func
};
HeaderHelp.defaultProps = {
  className: "",
  fill: "#063AC9",
  width: 14,
  height: 20,
  onClick: () => null
};
